
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1420',
  depVersions: {
  "customer-portal-app": "static-1.1420",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.438",
  "data-fetching-client": "static-1.9347",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.371",
  "growth-payments-core": "static-1.24354",
  "head-dlb": "static-1.4702",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5263",
  "hs-test-utils": "static-1.7655",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9146",
  "hubspot-dlb": "static-2.1773",
  "hubspot-prosemirror": "static-1.17256",
  "hubspot-url-utils": "static-1.3825",
  "HubStyleTokens": "static-2.11092",
  "I18n": "static-7.1535",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6126",
  "payment-link-components": "static-1.22581",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6540",
  "quartz-core": "static-1.5759",
  "react": "static-7.174",
  "react-colorpicker": "static-2.9887",
  "react-dlb": "static-1.68",
  "react-utils": "static-2.5061",
  "rich-text-lib": "static-1.19245",
  "transmute": "static-2.77",
  "ui-addon-upgrades": "static-9.17378",
  "ui-components-test-utils": "static-1.5230",
  "UIComponents": "static-3.8039",
  "foundations-assets": "static-1.4504",
  "foundations-components": "static-1.7242",
  "foundations-theming": "static-1.4075",
  "foundations-theming-specialty": "static-1.1791",
  "framer-motion": "static-1.63",
  "history": "static-4.47",
  "metrics-js": "static-1.9296",
  "PortalIdParser": "static-2.334",
  "portals-platform-lib": "static-1.389",
  "quartz-config": "static-1.318",
  "quick-fetch": "static-1.3611",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16301",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7814",
  "styled-components": "static-2.83",
  "tanstack-table": "static-1.48",
  "ui-addon-draggable": "static-3.4417",
  "ui-addon-react-router-dom": "static-1.9215",
  "usage-tracker": "static-1.7009",
  "usage-tracker-anonymous": "static-1.5426",
  "usage-tracker-core": "static-1.6859",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven": "static-3.5564",
  "raven-hubspot": "static-1.5871",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.65",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3108",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2817",
  "quartz-webpack": "static-1.2764",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.75",
  "commerce-analytics-service-client": "static-1.3354",
  "customer-data-objects": "static-1.7284",
  "frontend-preferences-client": "static-1.7596",
  "laboratory-lib": "static-3.6813",
  "onboarding-scopes": "static-1.6115",
  "rpc-client-utils": "static-1.4275",
  "ui-addon-opt": "static-4.8062",
  "HeadJS": "static-2.685",
  "hs-test-utils-bend-plugin": "static-1.2766",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "ts-schema": "static-1.3786",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7261",
  "cssUtils": "static-1.691",
  "customer-data-ui-utilities": "static-1.9495",
  "HubStyle": "static-2.11400",
  "knowledge-content-types": "static-1.8266",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.215",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.481",
  "ui-addon-emoji-picker": "static-1.9563",
  "ui-addon-i18n": "static-1.10798",
  "ui-business-units-lib": "static-1.8681",
  "ui-shepherd-react": "static-3.9812",
  "video-components-external": "static-1.10167",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4007",
  "commerce-tours-lib": "static-1.5520",
  "customer-data-properties": "static-1.50396",
  "getting-started-shared-tasks": "static-1.17495",
  "growth-onboarding-reliability": "static-1.4762",
  "onboarding-tours": "static-1.16087",
  "reference-resolvers-lite": "static-1.7765",
  "sales-checkout-service-client": "static-1.3366",
  "ui-addon-iframeable": "static-1.8678",
  "user-context": "static-1.4760",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.765",
  "hubspotter-http": "static-1.4360",
  "icons": "static-2.608",
  "mobile-manifest-mixins": "static-1.458",
  "quartz-auth": "static-1.215",
  "quartz-head": "static-1.205",
  "quartz-test": "static-1.215",
  "ui-fonts": "static-1.354",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9103",
  "data-token-picker": "static-1.15836",
  "FileManagerLib": "static-1.38148",
  "property-translator": "static-1.5086",
  "atom": "static-1.4746",
  "feature-store-service-types": "static-1.4201",
  "merchandise-lib": "static-1.253",
  "purchase-motions-components": "static-1.5291",
  "salesImages": "static-1.518",
  "self-service-api": "static-1.9897",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4192",
  "foundations-components-test-utils": "static-1.4725",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.92",
  "ui-images": "static-2.1051",
  "bend-plugin-foundations-components": "static-1.3511",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "trellis-assets": "static-1.928",
  "bend-plugin-foundations-theming": "static-1.2558",
  "foundations-theming-base": "static-1.3060",
  "stylex": "static-1.25",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4149",
  "react-flip-move": "static-1.63",
  "bender-build-tools": "static-1.2779",
  "inbound-db-properties-service-client": "static-1.3560",
  "superstore": "static-1.4440",
  "feedback-loader": "static-1.28632",
  "ai-components-ui-library": "static-1.8011",
  "ui-addon-video-player": "static-1.8395",
  "ui-coaching-tips": "static-1.27581",
  "sassPrefix": "static-1.149",
  "react-dnd-compat": "static-1.4297",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2134",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7832",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4321",
  "content-media-composition-data-lib": "static-1.10902",
  "content-media-compositions": "static-2.14909",
  "idb-keyval": "static-1.37",
  "immer": "static-1.33",
  "immerable": "static-1.3829",
  "magpie-lib": "static-1.5247",
  "magpie-types": "static-1.4707",
  "media-bridge-lib": "static-1.18360",
  "video-data-lib": "static-1.33825",
  "commerce-products-lib": "static-1.8455",
  "crm-message-bus": "static-1.41993",
  "growth-data-modal": "static-1.5003",
  "hubspot-apollo-client": "static-1.4553",
  "onboarding-tours-client": "static-1.4301",
  "calling-global-api": "static-1.63209",
  "calling-internal-common": "static-1.30961",
  "calling-lifecycle-internal": "static-1.64591",
  "calling-lifecycle-messages": "static-1.56885",
  "conditional-properties-service-client": "static-1.3504",
  "crm-links": "static-1.5917",
  "customer-data-objects-ui-components": "static-1.12673",
  "customer-data-property-utils": "static-1.7738",
  "external-options-client-types": "static-1.3865",
  "file-manager-components": "static-1.22508",
  "framework-data-schema-resolvers": "static-1.6537",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.322",
  "inbound-db-meta-service-client": "static-1.3341",
  "inbounddb-objects-service-types": "static-1.3931",
  "meetings-icalendar-utils-lib": "static-1.306",
  "multi-currency-client-types": "static-1.3404",
  "object-builder-ui-client": "static-1.47543",
  "pipeline-validation-client-types": "static-1.3668",
  "property-value-citations": "static-1.1010",
  "pulse": "static-1.156",
  "smart-property-lib": "static-1.5415",
  "tiered-pricing": "static-1.625",
  "ui-addon-form-validation": "static-1.10669",
  "growth-onboarding-confetti": "static-1.2725",
  "growth-onboarding-next-action-utils": "static-1.1162",
  "navigation-components": "static-1.16895",
  "onboarding-tours-utils": "static-1.153",
  "ui-shepherd-tracker": "static-1.7193",
  "ui-universal-auth": "static-1.8512",
  "batch-promise": "static-1.1200",
  "navigation-messaging": "static-1.6222",
  "getting-started-shared-tasks-store": "static-1.16613",
  "hubspotter-http-shared-msw-handlers": "static-1.9144",
  "audio-components": "static-1.5429",
  "FileManagerCore": "static-1.38007",
  "FileManagerImages": "static-1.35659",
  "video-components": "static-1.12170",
  "growth-monetization-service-types": "static-1.4208",
  "nav-client-types": "static-1.2005",
  "purchase-motions-api": "static-1.5294",
  "signup-constants": "static-1.18126",
  "signup-ui-url-generator": "static-2.7711",
  "trials-service-types": "static-1.3609",
  "chatspot-core": "static-1.19824",
  "ContentUtils": "static-1.67200",
  "copilot-toolkit": "static-1.10204",
  "growth-onboarding-feedback-components": "static-1.6259",
  "hls.js": "static-1.32",
  "reactive-lib": "static-1.399",
  "simple-logging-lib": "static-1.2723",
  "customer-data-tracking": "static-1.6534",
  "products-iframe-lib": "static-1.7007",
  "products-ui-components-shared-msw-handlers": "static-1.9528",
  "hubspot-apollo-cache": "static-1.12",
  "calling-error-reporting": "static-1.30967",
  "shared-worker-versioning": "static-1.10691",
  "calling-usage-tracker": "static-1.6212",
  "calling-orchestration-shared-library": "static-1.34397",
  "conversations-skeleton-state": "static-1.6925",
  "usage-tracker-container": "static-1.6999",
  "location-customization-utils-lib": "static-1.8139",
  "crm-pipelines-api-client-types": "static-1.3846",
  "framework-builder-read-service-client": "static-1.3729",
  "framework-data-schema-quick-fetch": "static-1.6442",
  "persist-promise": "static-1.3357",
  "directed-graph": "static-1.607",
  "event-emitter": "static-1.599",
  "breeze-intelligence-kit": "static-1.5132",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9229",
  "fsm": "static-1.3404",
  "policy-lib": "static-1.6475",
  "react-tinymce": "static-1.54268",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9292",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53394",
  "tinymce-plugins": "static-1.56508",
  "tinymce-themes": "static-1.55364",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4198",
  "video-embed": "static-1.34659",
  "content-icons-ui": "static-1.2107",
  "social-insights-client-types": "static-1.21049",
  "eligibility-engine-service-types": "static-1.2890",
  "chatspot-client-types": "static-1.10310",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4475",
  "integrations-lib": "static-1.15000",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.3966",
  "calling-orchestration-schema": "static-1.34622",
  "crm-record-cards-service-types": "static-1.3341",
  "highcharts": "static-8.97",
  "trellis-story-utils": "static-1.4197",
  "storybook-react": "static-1.26",
  "hub-http-contrib": "static-1.2721",
  "interframe": "static-3.4462",
  "tinymce-data": "static-1.39479",
  "ui-addon-sales-email": "static-1.4888",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11812",
  "layout-dnd-utils": "static-1.10787",
  "react-codemirror": "static-1.10276",
  "ui-brand-identity-lib": "static-1.13338",
  "NamespacedHubStyle": "static-2.8783",
  "outpost": "static-1.3887",
  "flux-actions": "static-1.294",
  "integrations-error-boundary-lib": "static-1.12415",
  "integrations-tracking-lib": "static-1.5257",
  "native-integrations-shared-strings": "static-1.7460",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10048",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67275",
  "layout-data-lib": "static-1.9112",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2670",
  "advanced-menus-core": "static-1.14611",
  "advanced-menus-lib": "static-1.11610",
  "ExportDialog": "static-6.10060",
  "ui-memberships-settings-lib": "static-1.33071",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14610",
  "simple-menus-lib": "static-1.16127"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1420",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.438",
  "data-fetching-client": "/data-fetching-client/static-1.9347",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.371",
  "growth-payments-core": "/growth-payments-core/static-1.24354",
  "head-dlb": "/head-dlb/static-1.4702",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5263",
  "hs-test-utils": "/hs-test-utils/static-1.7655",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9146",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17256",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyleTokens": "/HubStyleTokens/static-2.11092",
  "I18n": "/I18n/static-7.1535",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6126",
  "payment-link-components": "/payment-link-components/static-1.22581",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6540",
  "quartz-core": "/quartz-core/static-1.5759",
  "react": "/react/static-7.174",
  "react-colorpicker": "/react-colorpicker/static-2.9887",
  "react-dlb": "/react-dlb/static-1.68",
  "react-utils": "/react-utils/static-2.5061",
  "rich-text-lib": "/rich-text-lib/static-1.19245",
  "transmute": "/transmute/static-2.77",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17378",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5230",
  "UIComponents": "/UIComponents/static-3.8039",
  "foundations-assets": "/foundations-assets/static-1.4504",
  "foundations-components": "/foundations-components/static-1.7242",
  "foundations-theming": "/foundations-theming/static-1.4075",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1791",
  "framer-motion": "/framer-motion/static-1.63",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9296",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "portals-platform-lib": "/portals-platform-lib/static-1.389",
  "quartz-config": "/quartz-config/static-1.318",
  "quick-fetch": "/quick-fetch/static-1.3611",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16301",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7814",
  "styled-components": "/styled-components/static-2.83",
  "tanstack-table": "/tanstack-table/static-1.48",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4417",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9215",
  "usage-tracker": "/usage-tracker/static-1.7009",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5426",
  "usage-tracker-core": "/usage-tracker-core/static-1.6859",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven": "/raven/static-3.5564",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.65",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3108",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2817",
  "quartz-webpack": "/quartz-webpack/static-1.2764",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.75",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3354",
  "customer-data-objects": "/customer-data-objects/static-1.7284",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7596",
  "laboratory-lib": "/laboratory-lib/static-3.6813",
  "onboarding-scopes": "/onboarding-scopes/static-1.6115",
  "rpc-client-utils": "/rpc-client-utils/static-1.4275",
  "ui-addon-opt": "/ui-addon-opt/static-4.8062",
  "HeadJS": "/HeadJS/static-2.685",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2766",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "ts-schema": "/ts-schema/static-1.3786",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7261",
  "cssUtils": "/cssUtils/static-1.691",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9495",
  "HubStyle": "/HubStyle/static-2.11400",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.215",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9563",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10798",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8681",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9812",
  "video-components-external": "/video-components-external/static-1.10167",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4007",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5520",
  "customer-data-properties": "/customer-data-properties/static-1.50396",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17495",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4762",
  "onboarding-tours": "/onboarding-tours/static-1.16087",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7765",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3366",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8678",
  "user-context": "/user-context/static-1.4760",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.765",
  "hubspotter-http": "/hubspotter-http/static-1.4360",
  "icons": "/icons/static-2.608",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.458",
  "quartz-auth": "/quartz-auth/static-1.215",
  "quartz-head": "/quartz-head/static-1.205",
  "quartz-test": "/quartz-test/static-1.215",
  "ui-fonts": "/ui-fonts/static-1.354",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9103",
  "data-token-picker": "/data-token-picker/static-1.15836",
  "FileManagerLib": "/FileManagerLib/static-1.38148",
  "property-translator": "/property-translator/static-1.5086",
  "atom": "/atom/static-1.4746",
  "feature-store-service-types": "/feature-store-service-types/static-1.4201",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "purchase-motions-components": "/purchase-motions-components/static-1.5291",
  "salesImages": "/salesImages/static-1.518",
  "self-service-api": "/self-service-api/static-1.9897",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4192",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4725",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.92",
  "ui-images": "/ui-images/static-2.1051",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3511",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.928",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2558",
  "foundations-theming-base": "/foundations-theming-base/static-1.3060",
  "stylex": "/stylex/static-1.25",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4149",
  "react-flip-move": "/react-flip-move/static-1.63",
  "bender-build-tools": "/bender-build-tools/static-1.2779",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3560",
  "superstore": "/superstore/static-1.4440",
  "feedback-loader": "/feedback-loader/static-1.28632",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8011",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8395",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27581",
  "sassPrefix": "/sassPrefix/static-1.149",
  "react-dnd-compat": "/react-dnd-compat/static-1.4297",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2134",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7832",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4321",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10902",
  "content-media-compositions": "/content-media-compositions/static-2.14909",
  "idb-keyval": "/idb-keyval/static-1.37",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3829",
  "magpie-lib": "/magpie-lib/static-1.5247",
  "magpie-types": "/magpie-types/static-1.4707",
  "media-bridge-lib": "/media-bridge-lib/static-1.18360",
  "video-data-lib": "/video-data-lib/static-1.33825",
  "commerce-products-lib": "/commerce-products-lib/static-1.8455",
  "crm-message-bus": "/crm-message-bus/static-1.41993",
  "growth-data-modal": "/growth-data-modal/static-1.5003",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4553",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4301",
  "calling-global-api": "/calling-global-api/static-1.63209",
  "calling-internal-common": "/calling-internal-common/static-1.30961",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64591",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56885",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3504",
  "crm-links": "/crm-links/static-1.5917",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12673",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7738",
  "external-options-client-types": "/external-options-client-types/static-1.3865",
  "file-manager-components": "/file-manager-components/static-1.22508",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6537",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.322",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3341",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3931",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.306",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3404",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47543",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3668",
  "property-value-citations": "/property-value-citations/static-1.1010",
  "pulse": "/pulse/static-1.156",
  "smart-property-lib": "/smart-property-lib/static-1.5415",
  "tiered-pricing": "/tiered-pricing/static-1.625",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10669",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2725",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1162",
  "navigation-components": "/navigation-components/static-1.16895",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.153",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7193",
  "ui-universal-auth": "/ui-universal-auth/static-1.8512",
  "batch-promise": "/batch-promise/static-1.1200",
  "navigation-messaging": "/navigation-messaging/static-1.6222",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16613",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9144",
  "audio-components": "/audio-components/static-1.5429",
  "FileManagerCore": "/FileManagerCore/static-1.38007",
  "FileManagerImages": "/FileManagerImages/static-1.35659",
  "video-components": "/video-components/static-1.12170",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4208",
  "nav-client-types": "/nav-client-types/static-1.2005",
  "purchase-motions-api": "/purchase-motions-api/static-1.5294",
  "signup-constants": "/signup-constants/static-1.18126",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "trials-service-types": "/trials-service-types/static-1.3609",
  "chatspot-core": "/chatspot-core/static-1.19824",
  "ContentUtils": "/ContentUtils/static-1.67200",
  "copilot-toolkit": "/copilot-toolkit/static-1.10204",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6259",
  "hls.js": "/hls.js/static-1.32",
  "reactive-lib": "/reactive-lib/static-1.399",
  "simple-logging-lib": "/simple-logging-lib/static-1.2723",
  "customer-data-tracking": "/customer-data-tracking/static-1.6534",
  "products-iframe-lib": "/products-iframe-lib/static-1.7007",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9528",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.12",
  "calling-error-reporting": "/calling-error-reporting/static-1.30967",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10691",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6212",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34397",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6925",
  "usage-tracker-container": "/usage-tracker-container/static-1.6999",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8139",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3846",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3729",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6442",
  "persist-promise": "/persist-promise/static-1.3357",
  "directed-graph": "/directed-graph/static-1.607",
  "event-emitter": "/event-emitter/static-1.599",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5132",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9229",
  "fsm": "/fsm/static-1.3404",
  "policy-lib": "/policy-lib/static-1.6475",
  "react-tinymce": "/react-tinymce/static-1.54268",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9292",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53394",
  "tinymce-plugins": "/tinymce-plugins/static-1.56508",
  "tinymce-themes": "/tinymce-themes/static-1.55364",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4198",
  "video-embed": "/video-embed/static-1.34659",
  "content-icons-ui": "/content-icons-ui/static-1.2107",
  "social-insights-client-types": "/social-insights-client-types/static-1.21049",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2890",
  "chatspot-client-types": "/chatspot-client-types/static-1.10310",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4475",
  "integrations-lib": "/integrations-lib/static-1.15000",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.3966",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34622",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3341",
  "highcharts": "/highcharts/static-8.97",
  "trellis-story-utils": "/trellis-story-utils/static-1.4197",
  "storybook-react": "/storybook-react/static-1.26",
  "hub-http-contrib": "/hub-http-contrib/static-1.2721",
  "interframe": "/interframe/static-3.4462",
  "tinymce-data": "/tinymce-data/static-1.39479",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4888",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11812",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10787",
  "react-codemirror": "/react-codemirror/static-1.10276",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13338",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8783",
  "outpost": "/outpost/static-1.3887",
  "flux-actions": "/flux-actions/static-1.294",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12415",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5257",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7460",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10048",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67275",
  "layout-data-lib": "/layout-data-lib/static-1.9112",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2670",
  "advanced-menus-core": "/advanced-menus-core/static-1.14611",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11610",
  "ExportDialog": "/ExportDialog/static-6.10060",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33071",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14610",
  "simple-menus-lib": "/simple-menus-lib/static-1.16127"
}
};
